import { Card, Col, Row } from 'react-bootstrap';
import GoogleMapSelector from '../../../../components/common/google-maps-selector/GoogleMapSelector';
import { useState } from 'react';

const CardMap = ({
    ubicacionInicial,
    miUbicacion,
    actualizarMiUbicacion,
    ubicaciones,
    ruta,
    header,
    footer,
}) => {
    const [ubicacionDefault] = useState({ lat: 20.9673702, lng: -89.5925857 });
    return (
        <div className="h-100 my-3" style={{ backgroundColor: 'white', borderRadius: '0.375rem' }}>
            {
                header || <></>
            }
            <div className="p-2" >
                <Row>
                    <Col md={12} xs={12}>
                        <GoogleMapSelector
                            className="vh-50"
                            mapStyle="Default"
                            initialCenter={ubicacionInicial.lat ? ubicacionInicial : ubicacionDefault}
                            myLocation={miUbicacion ?? []}
                            setMyLocation={actualizarMiUbicacion}
                            markers={ubicaciones ?? []}
                            waypoints={ruta ?? []}
                            showStreetView={false}
                        />
                    </Col>
                </Row>
            </div>
            {
                footer || <></>
            }
        </div>
    );
};

export default CardMap;